import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { clearOverviewData } from 'reducers/overview/slice.js';
import { pecrData } from 'reducers/pecr-info/slice';
import { userInfo as userInfoAction } from 'reducers/user-info/slice';
import { cn, isDevEnvironment } from 'utils';
import Administration from './Administration.js';
import Logout from './Logout.js';
import MyPecrDropdown from './MyPecrDropdown.js';
import MyToDoLink from './MyToDoLink.js';
import { headerMenuList, menuText } from './navStyle.js';
import ReportDropdown from './ReportDropdown.js';

// Nav-Bar field Component
const Navbar = props => {
  const { userInfo } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const urlInfo = window.location.toString().split('/');
  const linkText = urlInfo.pop();
  const listBookmark = urlInfo.pop();

  const navigateToCreataPecr = () => {
    dispatch(clearOverviewData({}));
    navigate('/Overview');
    dispatch(pecrData({ key: 'insertId', value: null }));
    dispatch(pecrData({ key: 'pecrId', value: null }));
  };

  //To make the actionMessageClosed false so that action popover appears on home page click only
  const handleHomeClick = () => {
    dispatch(
      userInfoAction({
        actionMessageClosed: false,
      })
    );
  };

  return (
    <div
      className={cn(
        'scrollbar-color z-[999] flex flex-wrap content-center justify-between bg-black pl-4 pr-4',
        {
          'bg-[#617080]': isDevEnvironment, // override background when dev env
        },
        '[&::-webkit-scrollbar-thumb]:bg-gray-400 [&::-webkit-scrollbar-thumb]:[border-radius:16px] [&::-webkit-scrollbar]:[width:4px]'
      )}
    >
      <div className="flex flex-wrap items-center">
        <div>
          <Link
            to={{ pathname: '/', search: location.search }}
            style={linkText === '' ? headerMenuList : menuText}
            onClick={handleHomeClick}
          >
            {t('Home')}
          </Link>
        </div>
        <div>
          {userInfo?.active?.toString() === '1' &&
            userInfo?.userId !== null &&
            userInfo?.userId.toString() !== '0' && (
              <Link
                to={'/Overview'}
                style={linkText === 'Overview' ? headerMenuList : menuText}
                onClick={() => {
                  navigateToCreataPecr();
                }}
              >
                {t('Create_New_PECR')}
              </Link>
            )}
        </div>
        <div>
          <Link
            to={{ pathname: '/List', search: location.search }}
            style={
              linkText === 'List' || listBookmark === 'List'
                ? headerMenuList
                : menuText
            }
          >
            {t('PECR_List')}
          </Link>
        </div>
        <div>
          {userInfo?.active?.toString() === '1' &&
            userInfo?.userId !== null &&
            userInfo?.userId.toString() !== '0' && (
              <MyToDoLink linkText={linkText} />
            )}
        </div>
        <div>
          <MyPecrDropdown navigate={navigate} location={location} />
        </div>
        <div>
          <ReportDropdown navigate={navigate} />
        </div>
        <div>
          {(userInfo?.role === 'Site Administrator' ||
            userInfo?.role === 'System Administrator') &&
            userInfo?.userId !== null &&
            userInfo?.userId.toString() !== '0' &&
            userInfo?.active?.toString() === '1' && (
              <Administration navigate={navigate} />
            )}
        </div>
      </div>
      {isDevEnvironment && (
        <div className="hidden items-center text-lg font-bold text-white lg:flex">
          {t('PECR_Dev_Env')}
        </div>
      )}
      <Logout />
    </div>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
  };
};

export default connect(mapStateToProps, null)(Navbar);
